import { SpxStorage } from "@softpak/components/spx-storage";
import { SharedStorageKeyEnum } from "src/app/shared/_config/storage/shared-storage-key-enum";
import { AddTarQueryI } from "./add-tar.query.int";
import { AddTarResponseI } from "./add-tar.result.int";
import { ExtAddTarQueryI } from "./add-tar.query.ext";
import { ExtAddTarI } from "./add-tar.result.ext";

export const MapAddTar = {
  mapQuery: (query: AddTarQueryI): ExtAddTarQueryI => {
    return {
        request: {
            pcClientGuid: SpxStorage.getSetting<SharedStorageKeyEnum>(SharedStorageKeyEnum.clientGUID),
            pcTar: query.tarNumber,
            pcVerificationCode: query.tarCode.toString(),
        }
    };
  },
  mapResult: (ext: ExtAddTarI, _params): AddTarResponseI => {
    return {
      piVBSBookingNr: ext.response.piVBSBookingNr,
      plOk: ext.response.plOk
    };
  },
};
